import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['logo'];

  changeCompany(event) {
    window.location.href = `image_generation/${event.target.value}`;
  }
}
